import React, { useState, useEffect } from "react";
import boltshiftImage from "../../images/newHome/trusted-by/boltshift.png"
import featherdevImage from "../../images/newHome/trusted-by/featherdev.png"
import globalbankImage from "../../images/newHome/trusted-by/globalbank.png"
import lightboxImage from "../../images/newHome/trusted-by/lightbox.png"
import nietzscheImage from "../../images/newHome/trusted-by/nietzsche.png"
import spheruleImage from "../../images/newHome/trusted-by/spherule.png"

function TrustedSection() {
    const companyList = [boltshiftImage, lightboxImage, featherdevImage, spheruleImage, globalbankImage, nietzscheImage];

    return (
        <>
            <div className="bg-[#FFF4DE] lg:rounded-tr-[1000px] px-6 md:px-10 py-10 md:mt-0">
                <div className="container mx-auto">
                    <div className="text-center mb-8">
                        <p className="font-medium text-[16px] leading-[24px] text-gray-600">Trusted by</p>
                    </div>

                    <div
                        className="
                            flex flex-nowrap overflow-x-auto scrollbar-none justify-start items-center gap-6
                            xl:flex-wrap xl:overflow-visible xl:justify-around
                        ">
                        {
                            companyList.map((companyImg, idx) => (
                                <div key={idx} className="flex-shrink-0">
                                    <img src={companyImg} alt={companyImg} />
                                </div>
                            ))
                        }
                    </div>
                </div>
            </div>

        </>
    )
}
export default TrustedSection;